import "./template.css";

import { Link } from "react-router-dom";
import ReadModal2 from "./readMore.js";
import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CarouselSlider from "./Carousel.js";
import CaseStudyCard from "./CaseStudyCard.js"

import Accordion from "./Accordion";
import "./Accordion.css";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

function CloudServices() {
  const [activeModal, setActiveModal] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const sliderRef = useRef(null);
  const modalRef = useRef(null);
  const [selectedSlide, setSelectedSlide] = useState(null);
  const settings = {
    // dots: true,
    // infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const slideData = [
    {
      id: 1,
      heading: "Tailored for Small and Midsize Tutors",
      text: "Specifically designed to meet the unique needs of individual tutors and small tutoring businesses.  ",
      buttonLabel: "Read More",
      modalContent: {
        // modalHeading: 'Modal Heading 1',
        modalText:
          "CloudCipher seamlessly integrates with existing workflows and software ecosystems, minimizing disruption and streamlining the adoption process. Whether migrating from another platform or implementing new security measures, CloudCipher ensures a smooth transition with minimal downtime.",
      },
    },
    {
      id: 2,
      heading: "Comprehensive Yet Simple",
      text: "Offers a wide range of features in an intuitive, easy-to-use interface.  ",
      buttonLabel: "Read More",
      modalContent: {
        modalHeading: "Modal Heading 2",
        modalText: "Modal Text 2",
      },
    },

    {
      id: 3,
      heading: "Security and Privacy",
      text: "Prioritizing the protection of educational content and student data. ",
      buttonLabel: "Read More",
      modalContent: {
        modalHeading: "Modal Heading 3",
        modalText: "Modal Text 3",
      },
    },

    {
      id: 4,
      heading: "Engagement and Interaction",
      text: "Tools designed to create an engaging and interactive learning environment.  ",
      buttonLabel: "Read More",
      modalContent: {
        modalHeading: "Modal Heading 4",
        modalText: "Modal Text 4",
      },
    },

    {
      id: 5,
      heading: "Performance Optimization",
      text: 'Continuous monitoring and optimization to ensure peak performance of your cloud resources."',
      buttonLabel: "Read More",
      modalContent: {
        modalHeading: "Modal Heading 5",
        modalText: "Modal Text 5",
      },
    },

    // {
    //   id: 6,
    //   heading: 'Sixth Slide',
    //   text: 'A different text for the second slide.',
    //   buttonLabel: 'Read More',
    //   modalContent: {
    //     modalHeading: 'Modal Heading 6',
    //     modalText: 'Modal Text 6',
    //   },
    // },

    // {
    //   id: 7,
    //   heading: 'Seventh Slide',
    //   text: 'A different text for the second slide.',
    //   buttonLabel: 'Read More',
    //   modalContent: {
    //     modalHeading: 'Modal Heading 7',
    //     modalText: 'Modal Text 7',
    //   },
    // },

    // {
    //   id: 8,
    //   heading: 'Eighth Slide',
    //   text: 'A different text for the second slide.',
    //   buttonLabel: 'Read More',
    //   modalContent: {
    //     modalHeading: 'Modal Heading 8',
    //     modalText: 'Modal Text 8',
    //   },
    // },
    // ... (more slides)
  ];


  let items = [
    {
      title: "Q: How does the platform ensure the security of my teaching content? ",
      content:
        "A: We use state-of-the-art encryption and access controls to ensure your content is accessible only to authorized users.  ",
    },
    {
      title: "Q: Can I track individual student progress across different subjects?",
      content:
        "A: Yes, our comprehensive logging system allows you to monitor each student's progress, attendance, and performance by subject.  ",
    },
    {
      title: "Q: Is the platform easy to use for someone with limited technical skills?",
      content:
        "A: Absolutely. We've designed the platform with a focus on user-friendliness, ensuring that tutors can easily navigate and utilize all features without technical difficulties.  ",
    },
   
    
   
  ];
 

  const openModal = (slide) => {
    setSelectedSlide(slide);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  // Handle clicks outside the modal to close it
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    window.addEventListener("mousedown", handleOutsideClick);

    return () => {
      window.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const modalContent = (
    <>
      <p className="modal-np">The Purpose Behind Our Online Tutor </p>
      <div className="modal-content-sections">
        <div className="modal-section">
          Our Online Tutor Platform is specifically designed to empower small and
          midsize tutoring operations to expand their reach, secure their content,
          and effectively manage their tutoring business online. With a focus on
          ease of use, security, and comprehensive functionality, we're committed to
          enriching the educational experience for both tutors and students alike.
        </div>
        <div className="modal-section">
          <strong>Student Progress Tracking</strong>
          <p>
            Online tutor platforms enable tutors to monitor and track students'
            progress and performance, providing valuable insights that can inform
            instructional strategies and interventions.
          </p>
        </div>
        <div className="modal-section">
          <strong>Efficient Course Management</strong>
          <p>
            By centralizing course materials, communication channels, and
            administrative functions, online tutor platforms streamline course
            management tasks, saving tutors time and effort.
          </p>
        </div>
        <div className="modal-section">
          <strong>Enhanced Digital Presence</strong>
          <p>
            For tutors looking to establish or enhance their digital presence,
            online tutor platforms offer a professional platform to showcase their
            expertise and attract students.
          </p>
        </div>
        <div className="modal-section">
          <strong>Maximized Teaching Impact</strong>
          <p>
            Ultimately, the purpose of an online tutor platform is to maximize the
            teaching impact of tutors by providing them with the tools and support
            they need to deliver high-quality instruction in a secure and effective
            online environment.
          </p>
        </div>
      </div>
    </>
  );

  return (
    <div>
      <div id="maindivs">
        <div id="carouselExampleCaptions" className="carousel slide">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src="/Images/onlinetutorfinal.png"
                className="d-block w-100 carousel-image-responsive"
                alt="slider first"
              />
              <div className="carousel-caption  d-md-block carousel-caption-responsive">
                <div className="component-1 component-1-responsive" >Online Tutor</div>

                <div
                  className="component-paras component-paras-responsive"
                >
                  "Empowering Tutors, Enriching Minds – Your Secure,
                  Comprehensive Online Tutoring Solution"
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-np2">
          {/* <!-- section2 title --> */}
          <div className="cont2-titles">
            {/* <div class="cont2-titletext">What is Online Tutor?</div> */}
          </div>

          {/* <!-- section part --> */}
          <div className="container21">
            {/* <!-- left part --> */}

            <div className="cont2-left cont2-text">
              <div
                className="left-text left-text-responsive"
              >
                The Online Tutor Platform offers an all-in-one solution for
                tutors seeking to bring their teaching services online. It
                provides a secure environment for educational content, detailed
                logs of student progress and subjects, and tools to manage and
                deliver courses effectively. Whether you're looking to
                transition your tutoring services online or enhance your
                existing digital presence, our platform is tailored to meet your
                needs, ensuring your content remains protected and your teaching
                impact maximized.
              </div>
            </div>

            {/* right part */}
            <div className="cont2-right cont2-text">
              <div className="right-text">
                <img
                  className="content2img"
                  src="/Images/presentationss.gif"
                  alt="Description of the image"
                />
              </div>
            </div>
          </div>
          <div className="readmore">
            <ReadModal2 buttonText="Read More" modalContent={
              <div>
                <p className="modal-np">The Purpose Behind Our Online Tutor Services</p>
                <div className="modal-section">
                  <strong>Live Virtual Classes</strong>
                  <p>Host interactive, real-time classes with seamless video and chat integration.</p>
                </div>
                <div className="modal-section">
                  <strong>Progress Tracking</strong>
                  <p>Monitor student progress, attendance, and performance analytics in one place.</p>
                </div>
                <div className="modal-section">
                  <strong>Resource Sharing</strong>
                  <p>Share assignments, notes, and resources easily with students.</p>
                </div>
                <div className="modal-section">
                  <strong>Flexible Scheduling</strong>
                  <p>Set up classes and reminders that fit your and your students' needs.</p>
                </div>
              </div>
            } />
          </div>
        </div>

        {/* section3 */}
        <section className="section3">
          <div className="cont2-title title ">Our Features</div>

          <div className="section3parts">
            {/* <div class="content-np item31">
              <div>
                <strong style={{
                  fontSize:'20px',marginLeft:'20px'
                }}> Content Security
    </strong>
                <p class="aligned-paragraph item3text">
                Advanced encryption and security measures to protect your educational materials and intellectual property. 
                </p>
              </div>
            </div> */}
            <div
              className="content-np item31"
            >
              <div>
                <strong className="feature-heading-responsive">
                  Content Security
                </strong>
                <p
                  className="aligned-paragraph item3text feature-paragraph-responsive"
                >
                  Advanced encryption and security measures to protect your
                  educational materials and intellectual property.
                </p>
              </div>
            </div>

            <div className="content-np item322">
              <strong
                className="item32-heading item31-conent feature-heading-responsive"
              >
                Student and Subject Logging
              </strong>

              <div className=" item31-conent-img  "></div>
              <p className="aligned-paragraph item3text feature-paragraph-responsive">
                Comprehensive logging features to track student progress,
                attendance, and subject matter coverage.
              </p>
            </div>

            <div className="content-np item33">
              <strong
                className="feature-heading-responsive"
              >
                {" "}
                Customizable Tutor Profiles
              </strong>
              <p className="aligned-paragraph item3text feature-paragraph-responsive">
                Personalized tutor profiles to showcase qualifications, teaching
                styles, and course offerings.
              </p>
              {/* <div class="item32-button"><button class="item32-button">Read more</button></div> */}
            </div>

            <div className="content-np item34">
              <strong
                className="feature-heading-responsive"
              >
                Course Management Tools
              </strong>
              <p
                className="aligned-paragraph item3texts feature-paragraph-responsive"
              >
                Intuitive tools for creating, managing, and delivering courses,
                including scheduling, assignments, and assessments.
              </p>
            </div>
            <div className="content-np item35">
              <strong
                className="feature-heading-responsive"
              >
                {" "}
                Interactive Learning Environments
              </strong>
              <p className="aligned-paragraph item3text feature-paragraph-responsive">
                Engaging, interactive tools such as live video sessions, forums,
                and quizzes to enhance the learning experience.
              </p>
            </div>

            <div className="content-np item36">
              <strong
                className="feature-heading-responsive"
              >
                Payment Integration
              </strong>
              <p className="aligned-paragraph item3text feature-paragraph-responsive">
                Secure payment gateways for easy processing of course fees and
                subscriptions.
              </p>
            </div>

            <div className="content-np item37">
              <strong
                className="feature-heading-responsive"
              >
                Analytics and Reporting
              </strong>
              <p className="aligned-paragraph item3text feature-paragraph-responsive">
                Detailed analytics and reports to monitor engagement,
                performance, and growth.
              </p>
            </div>
          </div>
          {/* <div class="readmore">
            <button class="read1">Read More</button>
          </div> */}
        </section>

        <div className="section4">
          
          <div className="main-cont">
            <div className="Cardcomp">
              <div className="card-container">
                <div className="row-ca">
                  <div className="col-ca">
                    <div className="card-head text-center">
                      <h2 className="head-t ">USP of Online Tutor Platforms</h2>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-container">
              <div className="row-ck">
                <div className="col-ck">
                  <div className="card-wrapper">
                    <div className="main-card">
                      <div className="innercon">
                        <div className="card-content1">
                          <h2>
                          Tailored for Small and Midsize Tutors{" "}
                            <FontAwesomeIcon icon={faArrowRight} />
                          </h2>
                          {/* <p>vbhf</p> */}
                        </div>
                        <img src="/Images/Tailored_for_Small_and_Midsize_Tutors.gif" alt="" />
                      </div>
                    </div>
                    <div className="hover-card">
                      <div className="hover-content">
                        <h2> Tailored for Small and Midsize Tutors </h2>
                        <p>
                        Specifically designed to meet the unique needs of individual tutors and small tutoring businesses. {" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-ck">
                  <div className="card-wrapper">
                    <div className="main-card">
                      <div className="innercon">
                        <div className="card-content1">
                          <h2>
                          Comprehensive Yet Simple
                            <FontAwesomeIcon icon={faArrowRight} />{" "}
                          </h2>
                          {/* <p>vbhf</p> */}
                        </div>
                        <img src="/Images/Seamless_Multi-Platform_Integration.gif" alt="" />
                      </div>
                    </div>
                    <div className="hover-card">
                      <div className="hover-content">
                        <h2>Comprehensive Yet Simple</h2>
                        <p>
                          {" "}
                          Offers a wide range of features in an intuitive, easy-to-use interface. {" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-ck">
                  <div className="card-wrapper">
                    <div className="main-card">
                      <div className="innercon">
                        <div className="card-content1">
                          <h2>
                          Security and Privacy{" "}
                            <FontAwesomeIcon icon={faArrowRight} />
                          </h2>
                          {/* <p>vbhf</p> */}
                        </div>
                        <img src="/Images/Secure_Payment_Processing.gif" alt="" />
                      </div>
                    </div>
                    <div className="hover-card">
                      <div className="hover-content">
                        <h2>Security and Privacy</h2>
                        <p>
                        Prioritizing the protection of educational content and student data.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-ck">
                  <div className="card-wrapper">
                    <div className="main-card">
                      <div className="innercon">
                        <div className="card-content1">
                          <h2>
                          Engagement and Interaction<FontAwesomeIcon icon={faArrowRight} />
                          </h2>
                          {/* <p>vbhf</p> */}
                        </div>
                        <img src="/Images/Engagement_and_Interaction.gif" alt="" />
                      </div>
                    </div>
                    <div className="hover-card">
                      <div className="hover-content">
                        <h2>Engagement and Interaction</h2>
                        <p>
                        Tools designed to create an engaging and interactive learning environment.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-ck">
                  <div className="card-wrapper">
                    <div className="main-card">
                      <div className="innercon">
                        <div className="card-content1">
                          <h2>
                          Support and Growth
                            <FontAwesomeIcon icon={faArrowRight} />
                          </h2>
                          {/* <p>vbhf</p> */}
                        </div>
                        <img src="/Images/Performance_Optimization.gif" alt="" />
                      </div>
                    </div>
                    <div className="hover-card">
                      <div className="hover-content">
                        <h2> Support and Growth</h2>
                        <p>
                        Dedicated support and tools for business growth, including marketing and student engagement analytics. 
                        </p>
                      </div>
                    </div>
                  </div>
                </div>


               
               
                
              </div>
            </div>
          </div>




          {/* <CarouselSlider/> */}
        </div>


        <div className="section5">
          <h1 className="section5heading">How we are Handling</h1>
          <div className="section5jsxcard">
            <CaseStudyCard
              imageUrl="/Images/casestudyimg1.jpg"
              title="Easy Onboarding"
              description="Guided setup process to quickly get your tutoring services online.  "
              // linkUrl="/platform/E-cart/casestudy-vitualwallet"
            />
            <CaseStudyCard
              imageUrl="/Images/casestudyimg2.jpg"
              title="Customization and Branding"
              description=" Tools to customize your platform presence, matching your branding and teaching philosophy. "
              linkUrl=""
            />
            <CaseStudyCard
              imageUrl="/Images/casestudyimg3.jpg"
              title="Continuous Support"
              description="Ongoing support from our team to assist with any questions or technical needs.  "
              linkUrl="/platform/E-cart/casestudy-vitualwallet"
            />

            <CaseStudyCard
              imageUrl="/Images/casestudyimg4.jpg"
              title="Regular Updates"
              description="Continuous updates to the platform, adding new features and enhancements based on tutor feedback. "
              linkUrl=""
            />

            {/* <div class="readmore">
  <button class="read">show More</button>
  </div> */}

            {/* section 6 */}
          </div>
        </div>

        <section className="FAQ">
        <div className="FAQbody">
          <h1 className="section5heading text-dark" >FAQ's for this service</h1>
          <Accordion items={items} />
        </div>
      </section>

      </div>
    </div>
  );
}

export default CloudServices;
